// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.title[data-v-789d3564] {\r\n\tposition: relative;\n}\n.w-card-title svg[data-v-789d3564] {\r\n\tmargin: 5px 5px 0 0;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
